<template>
    <div class="timeline">
        <div v-for="(item,index) in timelineList" :key="index" :style="{color:item.color}" class="item">

            <div  class="point" v-if="index!=timelineList.length-1" >{{index+1}}</div>
            <div  class="point" v-else  style="background: #0B70FE;color: #fff"><i class="el-icon-check"></i></div>
            <div class="item-right"  :style="{'border-left':index!=timelineList.length-1?'2px solid #e4e7ed':'0'}">

                <div class="time">
                    <slot :name="'header' + index"></slot>
                    <i v-if="item.isOpen" @click="openContent(index)" class="el-icon-arrow-down" ></i>
                    <i v-else @click="openContent(index)"  class="el-icon-arrow-down " ></i>
                </div>
                <div class="contentBOX">
                    <div class="content-box"  v-if="item.isOpen">
                        <slot :name="'content' + index"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props:{
            timelineList:{
                type: Array,
                default: function _default() {
                    return   [
                        {
                            "isOpen":false,
                            "handleType":"1",
                            "centerName":"浆洗街街道",
                            "content":null,
                            "address":"四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
                            "handleDate":"2020-09-27 13:45:53",
                            "handleUserName":"张靖宇",
                            "id":"70287db8-c6a9-4b8d-9cfb-5354892f156a",
                            "createGmt":"2020-09-27T13:45:53.000+0800",
                            "handleTypeName":"发起报警",
                            "alarmRemarkLogVo":{
                                "id":null,
                                "content":null,
                                "resultContent":null,
                                "fileUrls":null,
                                "imageUrls":null,
                                "voiceUrls":null,
                                "alarmGradeId":null,
                                "alarmGradeName":null,
                                "processTime":"2020-09-27 13:45:53",
                                "fileForAddClueVos":null
                            },
                            "alarmHandlerTaskNodeList":null,
                            "alarmType":"一键报警",
                            "longitude":104.066387,
                            "latitude":30.544757,
                            "devicePerson":null
                        },    {
                            "isOpen":false,
                            "handleType":"1",
                            "centerName":"浆洗街街道",
                            "content":null,
                            "address":"四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
                            "handleDate":"2020-09-27 13:45:53",
                            "handleUserName":"张靖宇",
                            "id":"70287db8-c6a9-4b8d-9cfb-5354892f156a",
                            "createGmt":"2020-09-27T13:45:53.000+0800",
                            "handleTypeName":"发起报警",
                            "alarmRemarkLogVo":{
                                "id":null,
                                "content":null,
                                "resultContent":null,
                                "fileUrls":null,
                                "imageUrls":null,
                                "voiceUrls":null,
                                "alarmGradeId":null,
                                "alarmGradeName":null,
                                "processTime":"2020-09-27 13:45:53",
                                "fileForAddClueVos":null
                            },
                            "alarmHandlerTaskNodeList":null,
                            "alarmType":"一键报警",
                            "longitude":104.066387,
                            "latitude":30.544757,
                            "devicePerson":null
                        },
                        {
                            "isOpen":false,
                            "handleType":"4",
                            "centerName":"中国",
                            "content":null,
                            "address":"四川省成都市武侯区萃华路88号靠近亚朵酒店(成都高新店)",
                            "handleDate":"2020-09-27 13:46:01",
                            "handleUserName":"超级管理员2",
                            "id":"68237508-91d9-4cbc-8922-71835a3a43e7",
                            "createGmt":"2020-09-27T13:45:59.000+0800",
                            "handleTypeName":"接警",
                            "alarmRemarkLogVo":null,
                            "alarmHandlerTaskNodeList":null,
                            "alarmType":"一键报警",
                            "longitude":104.066387,
                            "latitude":30.544757,
                            "devicePerson":null
                        }];
                }
            }
        },
        name: "timeline",
        methods:{
            lineColor(color,index){
                let i;
                this.timelineList.forEach((item,j)=>{
                    if(item.color){
                        i = j
                    }
                })
                if(color&&i!=index){
                    return color
                }
            },

            openContent(inx){
                this.timelineList[inx].isOpen = !this.timelineList[inx].isOpen;
            }
        }
    }
</script>

<style  lang="less">
    .timeline{
        margin: 10px;
        .item{
            font-size: 12px;
            color: #666;
            display: flex;
            align-content: center;
            position: relative;
            height: auto;
            top:10px;
            .el-icon-arrow-down{
                font-size: 16px;
                font-weight: 600;
            }
            .handleType{
                margin: 0 5px;
            }
            .alarmType{
                font-weight: bolder;
                color: #0B70FE;
            }
            .centerName{
                display: inline-block;
                border: 1px solid #000;
                padding: 2px 5px;
                border-radius:10px ;
                margin: 0 5px;
            }
            .handleUserName{
                font-weight: bolder;

            }
        }
        .point{
            width:26px;
            height: 20px;
            z-index: 2;
            text-align: center;
            line-height: 20px;
            background:#d4ecff;
            border-radius: 50%;
        }
        .line{
            position: absolute;
            left: 5px;
            top: 12px;
            width: 2px;
            height: auto;
            background: #e4e7ed;
        }
        .item-right{
            margin-left: 14px;
            padding:0 0 0 30px;
            width: 100%;
            position: relative;
            left: -25px;

            .contentBOX {
                min-height: 30px;
                .content-box {
                    animation: showHeight ease 1s;
                    margin: 10px 10px 10px 0;
                    background: rgba(158, 239, 245, 0.3);
                    padding: 15px;
                    .content p span {
                        margin-right: 10px;
                    }
                }

            }
        }
    }
    @keyframes showHeight {
        0% {
            height: 0;
            opacity: 0;
        }
        100% {
            height: 100%;
            opacity: 1;
        }
    }
</style>
